import React, { Component } from "react";
import { connect } from "react-redux";

import CoffeeTableBookAlert from "../../notifications/onboarding/alerts/dashboard/coffeeTableBookAlert";

class CompanyDashboardAlerts extends Component {
  render = () => {
    return (
      <>
        <CoffeeTableBookAlert />
      </>
    );
  };
}

const mapStoreToProps = () => {
  return {};
};

const mapActionsToProps = {};

export default connect(
  mapStoreToProps,
  mapActionsToProps,
)(CompanyDashboardAlerts);
